import { PaymentDetail } from './../entities/payment-detail';
import { Injectable, Injector } from '@angular/core'; 
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class PaymentDetailService extends BaseCrudService<PaymentDetail> {

  public uri = '/api/paymentDetail/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance PaymentDetailService');
  }

  buildSentence(entity?: PaymentDetail, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      if (entity.voucherMain) {
        query = query.concat(
          `voucherMain.id${QueryOperator.Equal}${entity.voucherMain.id}${QueryOperator.Split}`
        );
      }

      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    return this.httpParams;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/payment-detail.service.ts